import { useCallback, useContext, useState } from 'react'
import { v4 } from 'uuid'

import { ReplicacheContext } from '../../providers/ReplicacheProvider/ReplicacheProvider'
import { addNewInspectionMedia } from '../../replicache/dviMedia/addNewInspectionMedia'
import { InspectionMediaEntry } from '../../sdk'
import EditMediaDialog from './EditMediaDialog'

export const AddMediaButtonCached = ({
  parentId,
  isMobileDevice,
  inspectionId,
  curIndex
}: {
  parentId: string
  isMobileDevice: boolean
  inspectionId: string
  curIndex: number
}) => {
  const { replicacheInstance } = useContext(ReplicacheContext)
  const [url, setUrl] = useState('')
  const handleClose = useCallback(() => {
    URL.revokeObjectURL(url)
    setUrl('')
  }, [url])

  const handleUpload = useCallback(
    (fileBlob: Blob) => {
      const id = v4()
      const newMediaEntry: InspectionMediaEntry = {
        id,
        mediaUrl: '',
        thumbnailUrl: '',
        info: {
          prompt: parentId,
          rank: curIndex,
          title: '',
          description: ''
        }
      }
      addNewInspectionMedia(
        fileBlob,
        newMediaEntry,
        inspectionId,
        replicacheInstance
      )
      handleClose()
    },
    [curIndex, handleClose, inspectionId, parentId, replicacheInstance]
  )
  return (
    <>
      <input
        accept="image/*"
        type="file"
        hidden
        onChange={(event) => {
          if (url) {
            URL.revokeObjectURL(url)
          } else {
            setUrl('')
          }
          const file = event.target!.files![0]
          if (file) {
            setUrl(URL.createObjectURL(file!))
          }
        }}
        capture={isMobileDevice ? 'environment' : undefined}
      />
      {url && <EditMediaDialog {...{ url, handleUpload, handleClose }} />}
    </>
  )
}
